<template lang="pug">
.goods-attr
  el-table.mb-40(:data="$parent.$parent.skuList" border style="width: 99.9%" v-if="type === 'NORMAL'"
    :header-cell-style="{ 'background': '#F2F2F2' }")
    el-table-column(label="操作" width="100px" align="center")
      template(slot-scope="scope")
        el-button(type="text" @click="tableOpeerate(scope, 'copy')") 复制
        el-button(type="text" @click="tableOpeerate(scope, 'remove')" 
          v-if="$parent.$parent.skuList.length > 1 && (scope.row.status === 'CREATE' || scope.row.status === 'INVALID')") 删除
    //- sku 固定值
    el-table-column(label="销售价" align="center")
      template(slot-scope="scope")
        el-input(placeholder="输入单价" v-model="scope.row.price" @blur="checkSkuPrice(scope.$index)"
          @input="only2Decimal(scope.$index,'price')" :class="$parent.$parent.priceErrors[scope.$index] ? 'bor-red' : ''")
    el-table-column(label="库存" align="center")
      template(slot-scope="scope")
        el-input(placeholder="输入库存" v-model="scope.row.stockNum" @input="onlyInteger(scope.$index)")
    el-table-column(label="单件重" align="center")
      template(slot-scope="scope")
        el-input(placeholder="输入单件重" v-model="scope['row']['amountPerUnit']" @input="only3Decimal(scope.$index)")
    el-table-column(label="进价" align="center")
      template(slot-scope="scope")
        el-input(placeholder="输入进价" v-model="scope.row.costPrice" @input="only2Decimal(scope.$index,'costPrice')")
    //- sku 销售属性
    el-table-column(v-for="item, index in $parent.$parent.skuPVPairList" :label="item.pTxt" align="center" :key="index")
      template(slot-scope="scope")
        el-input(placeholder="请输入" v-model="scope['row'].itemSkuPVPairList[index].vTxt"
          v-if="item.type === 'TEXT'")
        el-select(v-model="scope['row'].itemSkuPVPairList[index].vTxt" placeholder="请选择"
          v-if="item.type === 'ENUM'" @change="checkSkuPrice(scope.$index, false, item.pTxt)")
          el-option(v-for="_item, _index in item.list" :key="_index" :label="_item.text" :value="_item.text")
        el-date-picker(type="date" :editable="false" v-model="scope['row'].itemSkuPVPairList[index].vTxt"
          v-if="item.type === 'DATE'")
    el-table-column(label="商家商品编号" align="center")
      template(slot-scope="scope")
        span(v-if="itemExtInfoVO.source === 3") {{scope['row']['TPCode']}}
        el-input(v-else placeholder="请输入" v-model="scope['row']['TPCode']" @input="only3Decimal(scope.$index)")
    el-table-column(label="skuId" align="center" prop="id"
      v-if="$parent.$parent.skuPVPairList[0] && $parent.$parent.skuPVPairList[0].id")
    el-table-column(label="状态" align="center")
      template(slot-scope="scope")
        span(v-if="scope.row.status === 'CREATE'") 未上架
        span(v-if="scope.row.status === 'VALID'") 已上架
        span(v-if="scope.row.status === 'INVALID'") 已下架
    el-table-column(label="操作" align="center")
      template(slot-scope="scope")
        el-button(type="text" v-if="scope.row.status === 'CREATE' || scope.row.status === 'INVALID'" @click="tableOpeerate(scope, 'valid')") 上架
        el-button(type="text" v-if="scope.row.status === 'VALID'" @click="tableOpeerate(scope, 'invalid')") 下架
  
  .indefinite(v-if="type === 'UNCERTAIN'")
    el-form(inline label-width="100px")
      el-form-item(label="单价" :rules="[ { required: true } ]" label-width="80px")
        el-input.w-185(placeholder="请输入单价" v-model="$parent.$parent.indefinite.marketPrice" @input="only2Decimal(0,'marketPrice')")
      el-form-item(label="单件重" :rules="[ { required: true } ]" label-width="90px")
        el-input.w-185(placeholder="请输入单件重" v-model="$parent.$parent.indefinite.itemExtInfoVO.amountPerUnit"
          @input="only3Decimal")
      el-form-item(label="库存总数量" :rules="[ { required: true } ]")
        el-input.w-185(placeholder="请输入库存总数量" v-model="$parent.$parent.indefinite.stockNum" @input="onlyInteger")
      el-form-item(label="进价" label-width="80px")
        el-input.w-185(placeholder="请输入进价" v-model="$parent.$parent.indefinite.costPrice" @input="only2Decimal(0,'costPrice')")
      el-form-item(label="最小起订量")
        el-input.w-185(placeholder="请输入最小起订量" @input="checkOrderAmount"
          v-model="$parent.$parent.indefinite.itemExtInfoVO.minOrderAmount")
      el-form-item(label="商家资源编号")
        span(v-if="itemExtInfoVO.source === 3") {{$parent.$parent.indefinite.itemExtInfoVO.tpCode}}
        el-input.w-185(v-else placeholder="请输入商家资源编号" v-model="$parent.$parent.indefinite.itemExtInfoVO.tpCode")
      el-form-item(label="商品总重量")
        span {{NP.round($parent.$parent.indefinite.itemExtInfoVO.amountPerUnit * $parent.$parent.indefinite.stockNum, 3)}}吨

</template>

<script>
import NP from 'number-precision'

export default {
  name: 'saleAttr',
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      NP,
      itemExtInfoVO: this.$parent.$parent.goodsData.itemExtInfoVO || {}
    }
  },
  methods: {
    /** 只能是整数 */
    onlyInteger(index) {
      if (this.type === 'NORMAL') {
        try {
          let stockNum = this.$parent.$parent.skuList[index].stockNum + ''
          stockNum = stockNum.replace(/[^\d]/g, '') || ''
          this.$parent.$parent.skuList[index].stockNum = stockNum
        } catch (e) {
          this.$parent.$parent.skuList[index].stockNum = 0
        }
      } else {
        try {
          let stockNum = this.$parent.$parent.indefinite.stockNum + ''
          stockNum = stockNum.replace(/[^\d]/g, '') || ''
          this.$parent.$parent.indefinite.stockNum = stockNum
        } catch (e) {
          this.$parent.$parent.indefinite.stockNum = 0
        }
      }
    },
    /** 限制起订量只能是整数 */
    checkOrderAmount(index) {
      try {
        let minOrderAmount = this.$parent.$parent.indefinite.itemExtInfoVO.minOrderAmount + ''
        minOrderAmount = minOrderAmount.replace(/[^\d]/g, '') || ''
        this.$parent.$parent.indefinite.itemExtInfoVO.minOrderAmount = minOrderAmount
      } catch (e) {
        this.$parent.$parent.indefinite.itemExtInfoVO.minOrderAmount = 0
      }
    },
    /** 只能有两位 */
    only2Decimal(index, key) {
      try {
        let price =
          this.type === 'NORMAL'
            ? this.$parent.$parent.skuList[index][key] + ''
            : this.$parent.$parent.indefinite[key] + ''
        price = price.replace(/[^\d.]/g, '')
        price = price.replace(/^\./g, '')
        price = price.replace(/\.{2,}/g, '.')
        price = price
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.')
        price = price.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
        this.type === 'NORMAL'
          ? (this.$parent.$parent.skuList[index][key] = price)
          : (this.$parent.$parent.indefinite[key] = price)
      } catch (e) {
        this.type === 'NORMAL'
          ? (this.$parent.$parent.skuList[index][key] = 0)
          : (this.$parent.$parent.indefinite[key] = 0)
      }
    },
    /** 校验sku价格 */
    checkSkuPrice(index, noTip, type) {
      let isNeedCheck = false
      if (this.$parent.$parent.maxPriceRange > 0 && (!type || type === '计价单位')) {
        console.log(this.$parent.$parent.propertyList)
        this.$parent.$parent.propertyList &&
          this.$parent.$parent.propertyList.forEach(item => {
            if (item.text === '计价单位' && item.value === '吨') {
              isNeedCheck = true
            }
          })
        let price = this.$parent.$parent.skuList[index].price * 100
        let maxPriceRange = this.$parent.$parent.maxPriceRange * 100
        let minPriceRange = this.$parent.$parent.minPriceRange * 100
        if ((price > maxPriceRange || price < minPriceRange) && isNeedCheck) {
          if (!this.$parent.$parent.priceErrors[index]) {
            this.$parent.$parent.priceErrors.splice(index, 1, true)
          }
          if (!noTip) {
            return this.$message.error('价格超出类目的价格范围')
          }
        } else {
          if (this.$parent.$parent.priceErrors[index]) {
            this.$parent.$parent.priceErrors.splice(index, 1, false)
          }
        }
      }
    },
    /** 只能有三位 */
    only3Decimal(index) {
      try {
        let amountPerUnit =
          this.type === 'NORMAL'
            ? this.$parent.$parent.skuList[index].amountPerUnit
            : this.$parent.$parent.indefinite.itemExtInfoVO.amountPerUnit
        amountPerUnit = String(amountPerUnit)
        amountPerUnit = amountPerUnit.replace(/[^\d.]/g, '')
        amountPerUnit = amountPerUnit.replace(/^\./g, '')
        amountPerUnit = amountPerUnit.replace(/\.{2,}/g, '.')
        amountPerUnit = amountPerUnit
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.')
        amountPerUnit = amountPerUnit.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
        this.type === 'NORMAL'
          ? (this.$parent.$parent.skuList[index].amountPerUnit = amountPerUnit)
          : (this.$parent.$parent.indefinite.itemExtInfoVO.amountPerUnit = amountPerUnit)
      } catch (e) {
        this.type === 'NORMAL'
          ? (this.$parent.$parent.skuList[index].amountPerUnit = 0)
          : (this.$parent.$parent.indefinite.itemExtInfoVO.amountPerUnit = 0)
      }
    },
    /** sku列表操作 复制&删除 */
    tableOpeerate(scope, type) {
      if (type === 'valid') {
        scope.row.status = 'VALID'
      }
      if (type === 'invalid') {
        scope.row.status = 'INVALID'
      }
      if (type === 'remove') {
        this.$parent.$parent.skuList.splice(scope.$index, 1)
        this.$parent.$parent.priceErrors.splice(scope.$index, 1)
      }
      if (type === 'copy') {
        let obj = {}
        for (let key in scope.row) {
          if (key === 'itemSkuPVPairList') {
            let list = []
            scope.row[key].forEach(item => {
              let _item = {}
              for (let _key in item) {
                _item[_key] = item[_key]
              }
              list.push(_item)
            })
            obj[key] = list
          } else if (key !== 'id') {
            obj[key] = scope.row[key]
          }
          obj.status = 'VALID'
        }
        this.$parent.$parent.skuList.splice(scope.$index + 1, 0, obj)
        this.$parent.$parent.priceErrors.splice(
          scope.$index + 1,
          0,
          this.$parent.$parent.priceErrors[scope.$index]
        )
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.w-185
  width 185px
</style>
